module.exports = __webpack_public_path__ + "img/coupon-5-line.38b72c23.svg";